import { currency } from '@/shared/format'
import productNotFound from '@/assets/product-not-found.png'

export function totalCost (state) {
  return state.cart.reduce((cost, product) => {
    let price = product.price
    if (product.variant) {
      price = product.variant.price
    }

    return (parseFloat(price) * product.quantity) + cost
  }, 0)
}

export function totalShoppingCart (state) {
  return state.cart.length
}

export function totalFormulatedProducts (state) {
  return state.cart.reduce((quantity, product) => {
    const formula = product.formula
    return formula ? quantity + 1 : quantity
  }, 0)
}

export function getProductCoverImage (state) {
  return function (index) {
    const product = state.cart[index]
    if (hasImages(product)) {
      return product.image_urls[0]
    }

    if (!product.variants) {
      return productNotFound
    }

    for (const variant of product.variants) {
      if (hasImages(variant)) {
        return variant.image_urls[0]
      }
    }

    return productNotFound
  }
}

function hasImages (product) {
  const images = product.image_urls

  return !!images && images.length > 0
}

export function getProductPrice (state) {
  return function (index) {
    const product = state.cart[index]
    if (product.price) {
      return currency(product.price)
    }

    if (product.variant) {
      return currency(product.variant.price)
    }

    return ''
  }
}

export function getProductQuantities (state) {
  return function (index) {
    const product = state.cart[index]
    if (product.variant) {
      const variant = product.variant

      return variant ? buildQuantitiesList(variant.quantity_in_stock) : buildQuantitiesList(0)
    }

    return buildQuantitiesList(product.quantity_in_stock)
  }
}

function buildQuantitiesList (totalQuantity) {
  const quantities = []

  for (let quantity = 1; quantity <= totalQuantity; quantity++) {
    quantities.push(quantity)
  }

  return quantities
}
